<template>
  <v-card width="700" class="mx-auto">
    <v-toolbar>
      <v-btn icon @click="closeRules">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="title">
        <span>{{ $t("promotionRules") }}</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-container>
      <div
        style="min-height: 300px"
        class="d-flex flex-column align-center "
        :class="$vuetify.breakpoint.smAndDown ? '' : 'px-5'"
      >
        <div
          v-if="rules"
          v-html="rules"
          class="mx-4"
        ></div>

        <div v-else class="d-flex flex-column mx-4">
          <div class="text-h5">
            {{ $t("newCasino.freespins.rules.titleDialogDepositCampaign") }}
          </div><br/>
          <span>{{ $t("newCasino.freespins.rules.first") }}</span>
          <span>{{ $t("newCasino.freespins.rules.second") }}</span>
          <span>{{ $t("newCasino.freespins.rules.third") }}</span>
          <span>{{ $t("newCasino.freespins.rules.fourth") }}</span>
          <span>{{ $t("newCasino.freespins.rules.fifth") }}</span>
          <span>{{ $t("newCasino.freespins.rules.sixth") }}</span>
        </div>
      </div>
    </v-container>
  </v-card>
</template>
<script>
export default {
  props: ["rules"],
  methods: {
    closeRules() {
      this.$emit("closeRules");
    },
  },
};
</script>
